import * as React from "react";
import { useCallback } from "react";
import { styled } from "@mui/material";
import { GenderValue } from "shared";
import { usePatientCase } from "../usePatientCase";
import { SectionTitle } from "./SectionMainTitle";

import { Gender } from "./gender";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useScreenSize } from "../util/useScreenSize";

import MaleIcon from "../../../assets/maleIcon.svg";
import FemaleIcon from "../../../assets/femaleIcon.svg";

//region [[ Styles ]]
const GenderPickerView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",

  [theme.breakpoints.down(MobileView)]: {
    marginLeft: "11px",
    alignItems: "unset",
    marginTop: "22px",
    paddingLeft: "7px",
    paddingRight: "7px",
  },
}));

const ButtonsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
});

const MainButtons = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
});

const Title = styled(SectionTitle)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.down(MobileView)]: {
    textAlign: "left",
    marginBottom: theme.spacing(8),
    marginLeft: theme.spacing(0),
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]
export interface GenderPickerProps {
  className?: string;
  onGenderChanged?: (newGender: GenderValue) => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
/***
 * Gender picker wizard based on state context using patientCase
 * @param onGenderChanged - handler callback for when the gender was set
 * @param GenderPickerProps
 * @constructor
 */
export const GenderPicker = ({
  onGenderChanged,
  ...props
}: GenderPickerProps) => {
  const { patientCase, handleSetGender } = usePatientCase();

  const { isMobile } = useScreenSize();

  const changeGender = useCallback(
    (newGender: GenderValue) => {
      handleSetGender(newGender);

      onGenderChanged && onGenderChanged(newGender);
    },
    [handleSetGender, onGenderChanged],
  );

  return (
    <GenderPickerView className={props.className}>
      <Title className={"gender-title"}>
        {isMobile ? "Select Gender" : "Gender"}
      </Title>
      <ButtonsContainer>
        <MainButtons>
          <Gender
            text={"Female"}
            src={FemaleIcon}
            onClick={() => changeGender(GenderValue.FEMALE)}
            selected={patientCase.gender === GenderValue.FEMALE}
          />
          <Gender
            text={"Male"}
            src={MaleIcon}
            onClick={() => changeGender(GenderValue.MALE)}
            selected={patientCase.gender === GenderValue.MALE}
          />
        </MainButtons>
      </ButtonsContainer>
    </GenderPickerView>
  );
};
